"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const axios_1 = __importDefault(require("axios"));
const Field_1 = __importDefault(require("../models/Field"));
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
class GisFilesService {
    constructor() {
        this.error = false;
        this.msg = '';
        this.code = 0;
        this.fields = [];
        this.filesMetadata = [];
        this.data = null;
    }
    async submitData(data) {
        var _a;
        const formData = new FormData();
        data.forEach((item, index) => {
            formData.append(`${index}[type]`, item.type);
            item.files.forEach((file, fileIndex) => {
                formData.append(`${index}[files][${fileIndex}]`, file);
            });
            if ('prjcode' in item)
                formData.append(`${index}[prj-code]`, item.prjcode.trim());
        });
        try {
            const response = await axios_1.default.post('/gisfiles/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            this.data = response.data;
            this.msg = '';
            this.code = 200;
            this.error = false;
        }
        catch (error) {
            if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) !== 200) {
                this.msg = error.response.data.messages;
                this.code = error.response.status;
                this.error = true;
            }
            else {
                this.msg = '';
                this.code = 200;
                this.error = false;
            }
        }
    }
    ;
    async fetchFiles(files, prjCode) {
        const data = [];
        files.forEach((file) => {
            const fileType = file.extension.toUpperCase();
            if (fileType === 'SHP') {
                let filesP = [];
                file.subFiles.forEach((fileT) => {
                    filesP.push(fileT.file);
                });
                const hasPrjFile = file.subFiles.some(subFile => subFile.extension === 'prj');
                if (hasPrjFile) {
                    data.push({
                        type: fileType,
                        files: filesP
                    });
                }
                else {
                    data.push({
                        type: fileType,
                        files: filesP,
                        prjcode: prjCode
                    });
                }
            }
            else {
                data.push({
                    type: fileType,
                    files: [file.file]
                });
            }
        });
        await this.submitData(data);
        this.fields = [];
        if (this.data) {
            for (const file of this.data.files) {
                for (const field of file.fields) {
                    const fieldObj = new Field_1.default({
                        id: 0,
                        fieldName: '',
                        farmId: 0,
                        farmName: '',
                        size: 0,
                        sizeUnit: 'hc',
                        managementPractice: null,
                        crop: new Crop_1.default({
                            id: -1,
                            name: '-',
                            color: '#eebb54',
                            icon: '-'
                        }),
                        geodata: field.geodata,
                        origin: file.name,
                        metadata: field.columns,
                        projection: '',
                        quoteId: field.quoteId,
                        hasBeenValidated: field.has_been_validated,
                        provider: 'setup-gis_file',
                        providerFieldId: ''
                    });
                    this.fields.push(fieldObj);
                }
            }
            this.data.files.forEach((file) => {
                const fileColumnsSummary = file.fields[0].columns.map((column) => ({
                    columnName: column.columnName,
                    columnValue: column.columnValue
                }));
                this.filesMetadata.push({
                    fileName: file.name,
                    columns: fileColumnsSummary
                });
            });
        }
    }
}
exports.default = GisFilesService;
